import styled from 'styled-components'

export const Gradient = styled.div`
	width: 100%;
	height: 5px;
	background: linear-gradient(to right, #0052CC, #8777D9);
`